import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';
import { Form } from 'components/@shared/Form/Form';
import { FormTextField } from 'components/@shared/Form/TextField';
import { Button, Stack, Typography } from '@mui/material';
import { SignUpFormData } from 'types/auth';
import { initialValues } from './constants';
import { validationSchema } from './validation';
import { FormPatternTextField } from 'components/@shared/Form/FormPatternTextField';
import { FormPasswordInput } from 'components/@shared/Form/PasswordInput';

interface Props {
    onSignUp: (values: SignUpFormData) => void;
}

const signUpStyles = {
    '&:hover': {
        cursor: 'pointer',
    },
};

export const SignUpForm = ({ onSignUp }: Props) => {
    const navigate = useNavigate();

    const goToLoginHandler = useCallback(
        () => navigate(PATH.LOGIN),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return (
        <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSignUp}>
            <Stack gap={2} pt={5} pb={3} maxWidth={380} mx="auto">
                <FormTextField name="firstName" label="First Name" fullWidth size="small" />
                <FormTextField name="lastName" label="Last Name" fullWidth size="small" />
                <FormTextField name="email" label="Email" fullWidth size="small" />
                <FormPatternTextField
                    format="###-###-####"
                    mask="_"
                    name="phoneNumber"
                    label="Phone"
                    fullWidth
                    size="small"
                />
                <FormPasswordInput name="password" label="Password" fullWidth size="small" />
                <FormPasswordInput name="confirmPassword" label="Confirm Password" fullWidth size="small" />
                <Button variant="contained" type="submit" fullWidth>
                    Sign Up
                </Button>
                <Typography
                    component="span"
                    color="primary"
                    fontWeight={600}
                    textAlign="center"
                    sx={signUpStyles}
                    onClick={goToLoginHandler}
                >
                    Login
                </Typography>
            </Stack>
        </Form>
    );
};
